<template>
    <a-row class="chartViewerBox">
        <component :is="reportKey" :dataList="dataList" :loading="loading"></component>
    </a-row>
</template>

<script>
    import reportByExtNum from './reportByExtNum';
    import reportBySupplier from './reportBySupplier';
    import reportByUser from './reportByUser';
    export default {
        components: {
            reportByExtNum,
            reportBySupplier,
            reportByUser
        },
        props: {
            reportKey: {
                type: String,
                default: ""
            }
        },
        computed: {
            loading() {
                return this.$store.state.loading;
            },
            dataList() {
                return this.$store.state.dataList;
            }
        }
    }
</script>

<style scoped="scoped" lang="scss">
    .chartViewerBox {
        // border: 1px solid red;
    }
</style>>